export function escapeHtmlAttr(text: unknown): string {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function escapeHtmlText(text: unknown): string {
  return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function stripHtmlToText(html: string): string {
  const tmp = document.createElement("div");
  tmp.innerHTML = sanitizeAnnotationHtml(html);
  const t = (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
  return t.length > 160 ? `${t.slice(0, 157)}…` : t;
}

/** Оставляет в HTML примечания только текст, переносы и картинки data:/blob:. */
export function sanitizeAnnotationHtml(html: string): string {
  const source = document.createElement("div");
  source.innerHTML = html || "";
  const clean = document.createElement("div");
  const blocks = new Set(["DIV", "P", "LI", "H1", "H2", "H3", "H4", "TR"]);

  const appendSafe = (node: Node, parent: HTMLElement): void => {
    if (node.nodeType === Node.TEXT_NODE) {
      parent.appendChild(document.createTextNode(node.textContent || ""));
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }
    const el = node as HTMLElement;
    if (el.tagName === "BR") {
      parent.appendChild(document.createElement("br"));
      return;
    }
    if (el.tagName === "IMG") {
      const src = el.getAttribute("src") || "";
      if (src.startsWith("data:image/") || src.startsWith("blob:")) {
        const img = document.createElement("img");
        img.src = src;
        img.alt = (el.getAttribute("alt") || "").slice(0, 200);
        const width = el.style.width;
        if (/^\d+(\.\d+)?(px|%)$/.test(width)) {
          img.style.width = width;
        }
        img.style.maxWidth = "100%";
        img.style.height = "auto";
        parent.appendChild(img);
      }
      return;
    }
    if (blocks.has(el.tagName) && parent.childNodes.length > 0) {
      parent.appendChild(document.createElement("br"));
    }
    for (const child of [...el.childNodes]) {
      appendSafe(child, parent);
    }
  };

  for (const child of [...source.childNodes]) {
    appendSafe(child, clean);
  }
  return clean.innerHTML;
}

export function safeCssColor(color: unknown): string {
  const value = String(color ?? "").trim();
  return /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value)
    ? value
    : "transparent";
}
